export default __webpack_public_path__ + "static/media/3631.f2441761.png";